import script from "./LogsBrowser.vue?vue&type=script&setup=true&lang=ts"
export * from "./LogsBrowser.vue?vue&type=script&setup=true&lang=ts"

import "./LogsBrowser.vue?vue&type=style&index=0&id=3e654b74&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3e654b74"]])

export default __exports__